import type { TBaseResponse } from "@/models/common.model"
import type { TApiDisciplineResponse, TDiscipline } from "@/models/discipline.model"
import type { HttpClient } from "@/services/http-common"
import { tryCatch } from "@/lib/try-catch"
import { DisciplineMapper } from "@/mappers/competition/discipline.mapper"
import ApiServiceFactory from "@/services/api-service-factory"

// Definición del tipo que viene directamente de la API
export type TDisciplineResponse = TBaseResponse<TApiDisciplineResponse[]>

export class DisciplineService {
  private httpClient: HttpClient

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient
  }

  async getAll(): Promise<TDiscipline[]> {
    try {
      const response = await tryCatch(this.httpClient.get<TDisciplineResponse>("disciplines/get-all"))
      const { data, error } = response
      if (error) {
        if (error.statusCode === 404) {
          // return an empty array when the discipline is not found
          console.log("Discipline not found")
          return []
        }
      }

      return DisciplineMapper.toDto(data)
    }
    catch (error) {
      console.log("Error al obtener las disciplinas:", error)
      return [] // Retornar array vacío en caso de error
    }
  }

  async getByCode(disciplineCode: string): Promise<TDiscipline | null> {
    try {
      const response = await tryCatch(this.httpClient.get<TDiscipline>(`disciplines/get-by-code/${disciplineCode.toUpperCase()}`))
      const { data, error } = response
      if (error) {
        if (error.statusCode === 404) {
          console.log("Discipline not found")
          return null
        }
      }

      return data
    }
    catch (error) {
      console.error("Error al obtener la disciplina:", error)
      return null
    }
  }
}

export const disciplineService = ApiServiceFactory.createService(DisciplineService, "disciplines")

export default DisciplineService
